import { TAB_ID } from './tabId';

export const triggerCrossTabLogout = () => {
	console.log(`[${TAB_ID}] Triggering cross-tab logout`);
	const channel = new BroadcastChannel('session-control');
	channel.postMessage({ type: 'logout', tabId: TAB_ID });
	setTimeout(() => channel.close(), 1000); // ✅ give time for other tabs to receive
};
